import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { ajTemplates as ajTemplatesApi } from 'redux/modules/api'
import { notification, setPage } from 'redux/modules/app'
import { schema } from 'models/aj-templates'
import appConfig from 'config'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api, auth, app }) => ({
        ajTemplates: api.ajTemplates,
        activeOrganization: auth.organization,
        commonLimit: app.commonLimit
      }),
      { ...ajTemplatesApi, notification, push, setPage }
    )
    class AjTemplates extends Component {
      static propTypes = {
        activeOrganization: PropTypes.object,
        ajTemplates: PropTypes.object.isRequired,
        getAjTemplates: PropTypes.func.isRequired,
        getAjTemplate: PropTypes.func.isRequired,
        createAjTemplate: PropTypes.func.isRequired,
        updateAjTemplate: PropTypes.func.isRequired,
        deleteAjTemplate: PropTypes.func.isRequired,
        removeCache: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        removeDetailData: PropTypes.func.isRequired,
        commonLimit: PropTypes.number,
        setAjTemplatesParams: PropTypes.func
      }

      componentDidMount() {
        let { ajTemplates } = this.props
        const { params, commonLimit, setAjTemplatesParams } = this.props

        if (config.list && config.useCommonLimit && commonLimit) {
          ajTemplates = {
            ...ajTemplates,
            limit: commonLimit
          }
          setAjTemplatesParams({ limit: commonLimit })
        }

        config.list && this.handleAjTemplates(ajTemplates)
        config.detail && params && params.id && this.handleAjTemplate(params.id)
        config.detail &&
          params &&
          !params.id &&
          this.props.setPage('New AJ template', true)
      }

      componentWillReceiveProps(nextProps) {
        const { ajTemplates } = this.props
        const { filter, limit, offset, sort } = nextProps.ajTemplates

        if (
          ajTemplates.filter !== filter ||
          ajTemplates.limit !== limit ||
          ajTemplates.offset !== offset ||
          ajTemplates.sort !== sort
        ) {
          config.list && this.handleAjTemplates(nextProps.ajTemplates)
        }
      }

      componentWillUnmount = () => this.props.removeDetailData()

      handleAjTemplates = ajTemplates => this.props.getAjTemplates(ajTemplates)

      handleAjTemplate = id => {
        this.props.getAjTemplate(id).then(({ body }) => {
          const ajTemplateGlobalId = get(body, 'id')
            ? `(${body.globalId || `ID: ${body.id}`})`
            : ''

          this.props.setPage(
            `${get(body, 'ajEventCategory.translationText')} ${
              ajTemplateGlobalId
            }`,
            true
          )
        })
      }

      handleUpdateAjTemplate = fields => {
        const id = fields.id
        const params = {
          organizationId: this.props.activeOrganization.id
        }
        this.props
          .updateAjTemplate(id, schema(fields, params))
          .then(body => this.handleUpdateSuccess(id, body))
          .catch(this.handleError)
      }

      handleCreateAjTemplate = fields => {
        const params = {
          organizationId: this.props.activeOrganization.id
        }

        this.props
          .createAjTemplate(schema(fields, params))
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleDeleteAjEventTemplate = id => {
        this.props
          .deleteAjTemplate(id)
          .then(this.handleRemoveSuccess)
          .catch(this.handleError)
      }

      handleCreateSuccess = () => {
        this.handleEnd(
          'New template has been created',
          'notifications.new_template_has_been_created'
        )
        this.props.push(`${appConfig.publicPath}/adventurous-journeys/templates`)
      }

      handleRemoveSuccess = () => {
        this.handleEnd(
          'Template has been removed',
          'notifications.template_has_been_removed'
        )
        this.props.push(`${appConfig.publicPath}/adventurous-journeys/templates`)
      }

      handleUpdateSuccess = (id, { body }) => {
        this.handleEnd(
          'Template has been updated',
          'notifications.new_template_has_been_updated'
        )
        this.props.setPage(get(body, 'eventName'), true)

        this.handleAjTemplate(id)
      }

      handleError = ({ body } = {}) => {
        console.log('err', body)
        this.props.notification(body && body.userMessage, 'error')
      }

      handleEnd = (text, intlKey) => {
        this.props.removeCache()
        this.props.notification(text, {
          status: 'success',
          intlKey
        })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            updateAjTemplate={this.handleUpdateAjTemplate}
            createAjTemplate={this.handleCreateAjTemplate}
            deleteAjEventTemplate={this.handleDeleteAjEventTemplate}
          />
        )
      }
    }
    return AjTemplates
  }
}

export default decorator
